import styled from 'styled-components';

export const ALertHeaderText = styled.div`
  font-size: 20px;
  line-height: 32px;
  color: rgba(50, 50, 93, 0.7);
`;








// WEBPACK FOOTER //
// src/components/Seminars/SeminarActions/styles.js